// Rând de tabel care deschide detaliul: activabil și din tastatură (ui-kit.md → Tabel). `@click:row` singur nu este suficient.
// Se întoarce din `row-props`: `{ ...rowActivationProps(() => open(item)) }`.
export const rowActivationProps = (activate) => ({
  tabindex: 0,
  onKeydown: (event) => {
    // Enter / Space pe un control din rând (link, buton, input) este al lui, nu al rândului.
    if (event.target !== event.currentTarget) return;
    if (event.key !== "Enter" && event.key !== " ") return;
    event.preventDefault();
    activate(event);
  },
});
